import { create } from "zustand";

export const useNotificationStore = create((set, get) => ({
  notifications: [],
  hasNotifications: false,

  addNotification: (notification) => {
    const newNotification = {
      id: Date.now(),
      timestamp: new Date(),
      read: false,
      ...notification,
    };

    set((state) => ({
      notifications: [...state.notifications, newNotification],
      hasNotifications: true,
    }));
  },

  showNotification: (type, message, duration = 5000) => {
    const notification = {
      id: Date.now(),
      type,
      message,
      timestamp: new Date(),
      read: false,
    };

    set((state) => ({
      notifications: [...state.notifications, notification],
      hasNotifications: true,
    }));

    if (duration > 0) {
      setTimeout(() => {
        get().removeNotification(notification.id);
      }, duration);
    }
  },

  clearNotifications: () => {
    set({
      notifications: [],
      hasNotifications: false,
    });
  },

  markAsRead: (notificationId) => {
    set((state) => ({
      notifications: state.notifications.map((notif) =>
        notif.id === notificationId ? { ...notif, read: true } : notif
      ),
    }));
  },

  removeNotification: (notificationId) => {
    set((state) => {
      const filteredNotifications = state.notifications.filter(
        (notif) => notif.id !== notificationId
      );
      return {
        notifications: filteredNotifications,
        hasNotifications: filteredNotifications.length > 0,
      };
    });
  },

  getUnreadCount: () => {
    const { notifications } = get();
    return notifications.filter((notif) => !notif.read).length;
  },
})); 